import React from 'react'
import { Select } from 'antd'
import { useSelect } from '@refinedev/antd'

/**
 * Multi-select of members by name → an array of profiles.user_id strings.
 * Server-side, debounced search via the Supabase data provider.
 */
export function MemberSelect({
  value,
  onChange,
}: {
  value?: string[]
  onChange?: (ids: string[]) => void
}) {
  const { selectProps } = useSelect<{ user_id: string; name: string }>({
    resource: 'profiles',
    optionLabel: 'name',
    optionValue: 'user_id',
    onSearch: (text) => [{ field: 'name', operator: 'contains', value: text }],
    pagination: { pageSize: 20 },
    filters: [{ field: 'user_id', operator: 'nnull', value: null }],
  })

  return (
    <Select<string[]>
      {...(selectProps as object)}
      mode="multiple"
      allowClear
      style={{ width: '100%' }}
      placeholder="Search members by name…"
      value={value}
      onChange={(v) => onChange?.(v as string[])}
      filterOption={false}
    />
  )
}
